<template>
  <v-navigation-drawer
    v-model="drawer"
    :width="400"
    temporary
    floating
    :left="direction === 'left'"
    :right="direction === 'right'"
    app>
    <v-toolbar color="white" flat dense>
      <v-container>
        <v-layout row wrap>
          <v-flex xs2>
            <v-btn class="k-orange-linear-text mx-0" icon flat fab small @click="drawer = false">
              <v-icon small>fas fa-angle-{{direction}}</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs10 class="text-xs-center" pr-5 pl-2>
            <div class="headline k-orange-linear-text pt-2">
              {{ title }}
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-toolbar>
    <v-container>
      <slot name="content"></slot>
      <v-layout row wrap>
        <v-flex xs4 text-xs-left>
          <v-btn flat color="grey" @click="deleteFilters()" v-if="deleteFiltersButton">Borrar</v-btn>
        </v-flex>
        <v-flex xs8 text-xs-right>
          <v-btn flat @click="drawer = false">Cerrar</v-btn>
          <v-btn flat class="k-orange-linear-text" @click="apply()" v-if="updateButton">Aceptar</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-navigation-drawer>  
</template>

<script>
import EventBus from '@/event-bus';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    direction: {
      type: String,
      default: 'right',
    },
    deleteFiltersButton: {
      type: Boolean,
      default: false,
    },
    updateButton: {
      type: Boolean,
      default: true,
    },
    bus: {
      type: Object,
      default() {
        return {
          open: 'openSidebar',
          close: 'closeSidebar',
          apply: 'sidebarApply',
          unapply: 'sidebarUnapply',
        };
      },
    },
  },
  data() {
    return {
      drawer: false,
    };
  },
  methods: {
    apply() {
      EventBus.$emit(this.bus.apply);
    },
    deleteFilters() {
      EventBus.$emit(this.bus.unapply);
    },
  },
  watch: {
    bus: {
      handler(newVal, oldVal) {
        EventBus.$off((oldVal || {}).open);
        EventBus.$off((oldVal || {}).close);
        EventBus.$on(newVal.open, () => {
          this.drawer = true;
        });
        EventBus.$on(newVal.close, () => {
          this.drawer = false;
        });
      },
      immediate: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/global/Sidebar.vue